(function () {
  'use strict';

  var V       = window.CL_VARIANTS;
  var COMPARE = window.CL_COMPARE || {};
  if (!V) return;

  /* ══════════════════════════════════
     STATE — checked is independent of variant selection
  ══════════════════════════════════ */
  var state = {
    hat:   { vid: null, color: null,               checked: false, comparePrice: COMPARE.hat   || 0 },
    dress: { vid: null, color: null, size: null,   checked: false, comparePrice: COMPARE.dress || 0 },
    shoes: { vid: null, color: null, size: null,   checked: false, comparePrice: COMPARE.shoes || 0 }
  };

  /* ══════════════════════════════════
     UTILITIES
  ══════════════════════════════════ */
  function fmt(cents) { return '$' + (parseInt(cents, 10) / 100).toFixed(2); }

  function setText(id, val) { var el = document.getElementById(id); if (el) el.textContent = val; }
  function showEl(id) { var el = document.getElementById(id); if (el) el.style.display = ''; }
  function hideEl(id) { var el = document.getElementById(id); if (el) el.style.display = 'none'; }

  function getVariant(list, opts) {
    return list.find(function (v) {
      return opts.every(function (o, i) { return v['option' + (i + 1)] === o; });
    }) || null;
  }

  function getVariantsByColor(list, color) {
    return list.filter(function (v) { return v.option1 === color; });
  }

  function getPrice(list, vid) {
    if (!vid) return 0;
    var v = list.find(function (v) { return v.id === vid; });
    return v ? parseInt(v.price, 10) : 0;
  }

  function hasSizeOption(product) {
    return (V[product] || []).some(function (v) { return v.option2; });
  }

  /* ══════════════════════════════════
     IMAGE SWAP
  ══════════════════════════════════ */
  function swapImg(imgEl, newSrc) {
    if (!imgEl || !newSrc) return;
    var cur = imgEl.src.split('?')[0];
    var nxt = newSrc.split('?')[0];
    if (cur === nxt) return;
    imgEl.classList.add('cl-fading');
    var tmp = new Image();
    tmp.onload  = function () { imgEl.src = newSrc; imgEl.classList.remove('cl-fading'); };
    tmp.onerror = function () { imgEl.classList.remove('cl-fading'); };
    tmp.src = newSrc;
  }

  function updateItemImg(product, color) {
    var imgEl = document.getElementById('cl-item-img-' + product);
    if (!imgEl) return;
    var matches = getVariantsByColor(V[product] || [], color);
    if (matches.length && matches[0].featured_image && matches[0].featured_image.src) {
      swapImg(imgEl, matches[0].featured_image.src);
    }
  }

  /* ══════════════════════════════════
     COLOR NAME → CSS (for swatch background)
  ══════════════════════════════════ */
  var COLOR_MAP = {
    'black':'#111','white':'#f8f8f8','beige':'#d4c8b8','cream':'#f5f0e8',
    'ivory':'#fffff0','nude':'#e2c4a8','blush':'#e8b4b8','pink':'#f4a7b9',
    'red':'#c0392b','burgundy':'#800020','wine':'#722f37','rose':'#c9788a',
    'camel':'#c49a6c','tan':'#cba06e','brown':'#8b5e3c','chocolate':'#7b3f2c',
    'navy':'#1a2744','blue':'#3b5998','cobalt':'#1e4d8c','denim':'#4e6d8c',
    'grey':'#9e9e9e','gray':'#9e9e9e','silver':'#c0c0c0','charcoal':'#555',
    'green':'#4a7c59','olive':'#6b7c45','sage':'#87a878','forest':'#2d5a3d',
    'khaki':'#c3b091','taupe':'#9e8e7e','mocha':'#967259','sand':'#d4b896',
    'gold':'#d4a843','mustard':'#e3ac32','yellow':'#f0d060','orange':'#e07028',
    'lilac':'#c8a2c8','purple':'#7b3f7f','lavender':'#b8a9c9','mauve':'#c8909a',
    'teal':'#3d8b8b','emerald':'#2d7d4e','mint':'#98d9c2','coral':'#e8735a'
  };

  function colorToCSS(name) {
    if (!name) return '#d4c8b8';
    var k = name.toLowerCase().trim();
    if (COLOR_MAP[k]) return COLOR_MAP[k];
    for (var key in COLOR_MAP) { if (k.indexOf(key) !== -1) return COLOR_MAP[key]; }
    return '#d4c8b8';
  }

  /* ══════════════════════════════════
     BUILD COLOR SWATCHES
     Uses Paris theme classes: color-swatch swatch-circle product-swatch-item
  ══════════════════════════════════ */
  function buildSwatches(product, variants) {
    var ul = document.querySelector('.cl-swatch-list[data-product="' + product + '"]');
    if (!ul) return;

    var seen = {};
    variants.forEach(function (v) {
      var c = v.option1;
      if (!c || seen[c]) return;
      seen[c] = true;

      var li = document.createElement('li');
      li.className = 'color-swatch swatch-circle product-swatch-item available';
      li.title = c;

      var span = document.createElement('span');
      span.className = 'swatch-variant-item swatch-variant-color';
      span.setAttribute('data-tooltip', c);
      span.style.backgroundColor = colorToCSS(c);
      li.appendChild(span);
      ul.appendChild(li);

      li.addEventListener('click', function () {
        ul.querySelectorAll('li').forEach(function (s) { s.classList.remove('active'); });
        li.classList.add('active');

        state[product].color = c;
        state[product].vid   = null;
        updateItemImg(product, c);

        // Clear size on color change
        if (state[product].size !== undefined) {
          state[product].size = null;
          var pillUl = document.querySelector('.cl-pill-list[data-product="' + product + '"]');
          if (pillUl) pillUl.querySelectorAll('li').forEach(function (p) { p.classList.remove('active'); });
          updatePillAvailability(product, c);
        }
        resolveVariant(product);
        runUpdate();
      });
    });
  }

  /* ══════════════════════════════════
     BUILD SIZE PILLS
     Uses Paris theme classes: product-swatch-item small-variant
  ══════════════════════════════════ */
  function buildPills(product, variants) {
    var ul = document.querySelector('.cl-pill-list[data-product="' + product + '"]');
    if (!ul) return;

    var seen = {};
    var hasSizes = false;

    variants.forEach(function (v) {
      if (!v.option2 || seen[v.option2]) return;
      seen[v.option2] = true;
      hasSizes = true;

      var li = document.createElement('li');
      li.className = 'product-swatch-item small-variant available';
      li.dataset.size = v.option2;

      var span = document.createElement('span');
      span.className = 'swatch-variant-item swatch-variant-option-name';
      span.textContent = v.option2;
      li.appendChild(span);
      ul.appendChild(li);

      li.addEventListener('click', function () {
        if (li.classList.contains('unavailable')) return;
        ul.querySelectorAll('li').forEach(function (p) { p.classList.remove('active'); });
        li.classList.add('active');
        state[product].size = v.option2;
        state[product].vid  = null;
        resolveVariant(product);
        runUpdate();
      });
    });

    if (hasSizes) {
      var row = document.getElementById('cl-' + product + '-size-row');
      if (row) row.style.display = '';
    }
  }

  /* ══════════════════════════════════
     PILL AVAILABILITY (by selected color)
  ══════════════════════════════════ */
  function updatePillAvailability(product, color) {
    var ul = document.querySelector('.cl-pill-list[data-product="' + product + '"]');
    if (!ul) return;
    var variants = V[product] || [];
    ul.querySelectorAll('li').forEach(function (li) {
      var size = li.dataset.size;
      var avail = variants.some(function (v) {
        return v.option1 === color && v.option2 === size && v.available !== false;
      });
      li.classList.toggle('unavailable', !avail);
      li.classList.toggle('available', avail);
    });
  }

  /* ══════════════════════════════════
     RESOLVE VARIANT FROM STATE
  ══════════════════════════════════ */
  function resolveVariant(product) {
    var s = state[product];
    if (!s.color) { s.vid = null; return; }

    if (hasSizeOption(product)) {
      if (s.size) {
        var v = getVariant(V[product], [s.color, s.size]);
        s.vid = v ? v.id : null;
      } else {
        s.vid = null; // color chosen, size not yet
      }
    } else {
      var v = getVariant(V[product], [s.color]);
      s.vid = v ? v.id : null;
    }

    // AUTO-CHECK: when variant fully resolved, check the checkbox
    if (s.vid && !s.checked) {
      s.checked = true;
      syncCheckbox(product, true);
    }
  }

  function syncCheckbox(product, checked) {
    var input = document.getElementById('cl-check-' + product);
    if (input) input.checked = checked;
  }

  /* ══════════════════════════════════
     CHECKBOX LOGIC
     ATC enabled when: ≥1 checked AND all checked have vid
  ══════════════════════════════════ */
  function isAtcEnabled() {
    var products = ['hat', 'dress', 'shoes'];
    var anyChecked = products.some(function (p) { return state[p].checked; });
    if (!anyChecked) return false;
    // Every checked product must have a resolved variant
    return products.every(function (p) {
      if (!state[p].checked) return true;
      return !!state[p].vid;
    });
  }

  function getCartItems() {
    return ['hat', 'dress', 'shoes']
      .filter(function (p) { return state[p].checked && state[p].vid; })
      .map(function (p) { return { id: state[p].vid, quantity: 1 }; });
  }

  /* ══════════════════════════════════
     MAIN UPDATE
  ══════════════════════════════════ */
  function runUpdate() {
    var hp = getPrice(V.hat,   state.hat.vid);
    var dp = getPrice(V.dress, state.dress.vid);
    var sp = getPrice(V.shoes, state.shoes.vid);

    // Per-product prices
    if (state.hat.vid)   setText('cl-hat-price',   fmt(hp));
    if (state.dress.vid) setText('cl-dress-price',  fmt(dp));
    if (state.shoes.vid) setText('cl-shoes-price',  fmt(sp));

    // Running total (only checked items)
    var total        = 0;
    var totalCompare = 0;
    ['hat', 'dress', 'shoes'].forEach(function (p) {
      if (state[p].checked && state[p].vid) {
        total        += getPrice(V[p], state[p].vid);
        totalCompare += state[p].comparePrice || 0;
      }
    });

    var anyCheckedWithVid = ['hat','dress','shoes'].some(function(p){ return state[p].checked && state[p].vid; });
    var totalStr = anyCheckedWithVid ? fmt(total) : '—';
    setText('cl-total-price',  totalStr);
    setText('cl-sticky-total', totalStr);

    // Compare-at total
    var compareEl = document.getElementById('cl-total-compare');
    if (compareEl) {
      if (anyCheckedWithVid && totalCompare > total) {
        compareEl.textContent = fmt(totalCompare);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    // Savings bar
    if (window.CL_SHOW_SAVINGS) {
      var savingsBar = document.getElementById('cl-savings-bar');
      var savingsText = document.getElementById('cl-savings-text');
      if (savingsBar && savingsText) {
        var saved = totalCompare - total;
        if (anyCheckedWithVid && saved > 0) {
          savingsText.textContent = 'You save ' + fmt(saved) + ' on this look';
          savingsBar.style.display = '';
        } else {
          savingsBar.style.display = 'none';
        }
      }
    }

    // ATC button
    var ok         = isAtcEnabled();
    var cartItems  = getCartItems();
    var cartTotal  = cartItems.reduce(function (sum, item) {
      return sum + getPrice(V[['hat','dress','shoes'].find(function(p){ return state[p].vid === item.id; })], item.id);
    }, 0);

    var atcLabel       = ok ? 'Add Look to Cart — ' + fmt(cartTotal) : 'Select options to continue';
    var atcLabelMobile = ok ? 'Add Look — ' + fmt(cartTotal) : 'Select options';

    setText('cl-atc-text',    atcLabel);
    setText('cl-sticky-text', atcLabelMobile);

    var btn = document.getElementById('cl-add-to-cart');
    if (btn) btn.disabled = !ok;
    var stickyBtn = document.getElementById('cl-sticky-btn');
    if (stickyBtn) stickyBtn.disabled = !ok;
  }

  /* ══════════════════════════════════
     HERO SLIDER
  ══════════════════════════════════ */
  var slideCount   = window.CL_LOOK_COUNT || 0;
  var currentSlide = 0;

  function goToSlide(index) {
    if (slideCount < 2) return;
    document.querySelectorAll('.cl-slide').forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    document.querySelectorAll('.cl-dot').forEach(function (d, i) {
      d.classList.toggle('is-active', i === index);
      d.setAttribute('aria-selected', String(i === index));
    });
    currentSlide = index;
  }
  function nextSlide() { goToSlide((currentSlide + 1) % slideCount); }
  function prevSlide() { goToSlide((currentSlide - 1 + slideCount) % slideCount); }

  function initSlider() {
    if (slideCount < 2) return;
    var prev = document.getElementById('cl-prev');
    var next = document.getElementById('cl-next');
    if (prev) prev.addEventListener('click', prevSlide);
    if (next) next.addEventListener('click', nextSlide);
    document.querySelectorAll('.cl-dot').forEach(function (dot) {
      dot.addEventListener('click', function () { goToSlide(parseInt(dot.dataset.index, 10)); });
    });
    var slider = document.getElementById('cl-slider');
    if (slider) {
      slider.setAttribute('tabindex', '0');
      slider.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { prevSlide(); e.preventDefault(); }
        if (e.key === 'ArrowRight') { nextSlide(); e.preventDefault(); }
      });
      var touchX = 0;
      slider.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchX;
        if (dx < -40) nextSlide(); else if (dx > 40) prevSlide();
      }, { passive: true });
    }
  }

  /* ══════════════════════════════════
     SIZE GUIDE MODALS
  ══════════════════════════════════ */
  function initModals() {
    // Open
    document.querySelectorAll('.cl-size-guide-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var product = btn.dataset.product;
        var modal = document.getElementById('cl-modal-' + product);
        if (modal) { modal.hidden = false; document.body.style.overflow = 'hidden'; }
      });
    });

    // Close (backdrop + X button)
    document.querySelectorAll('.cl-modal-close').forEach(function (el) {
      el.addEventListener('click', function () {
        var modal = el.closest('.cl-modal');
        if (modal) { modal.hidden = true; document.body.style.overflow = ''; }
      });
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.cl-modal:not([hidden])').forEach(function (modal) {
          modal.hidden = true; document.body.style.overflow = '';
        });
      }
    });
  }

  /* ══════════════════════════════════
     ADD TO CART
  ══════════════════════════════════ */
  function addToCart() {
    var items = getCartItems();
    if (!items.length) return;

    var btn1 = document.getElementById('cl-add-to-cart');
    var btn2 = document.getElementById('cl-sticky-btn');
    var err  = document.getElementById('cl-error');

    [btn1, btn2].forEach(function (b) { if (b) b.disabled = true; });
    setText('cl-atc-text',    'Adding…');
    setText('cl-sticky-text', 'Adding…');
    if (err) err.style.display = 'none';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.ok ? r.json() : r.json().then(function (e) { throw new Error(e.description || 'Error'); });
      })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (e) {
        [btn1, btn2].forEach(function (b) { if (b) b.disabled = false; });
        setText('cl-atc-text',    'Add Look to Cart');
        setText('cl-sticky-text', 'Add Look');
        if (err) { err.textContent = e.message; err.style.display = 'block'; }
      });
  }

  /* ══════════════════════════════════
     INIT
  ══════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {

    // Build swatches + pills
    ['hat', 'dress', 'shoes'].forEach(function (product) {
      buildSwatches(product, V[product] || []);
      buildPills(product, V[product] || []);
    });

    // Checkbox manual toggle
    document.querySelectorAll('.cl-item-check').forEach(function (input) {
      input.addEventListener('change', function () {
        var product = input.dataset.product;
        state[product].checked = input.checked;
        runUpdate();
      });
    });

    // Slider
    initSlider();

    // Size guide modals
    initModals();

    // ATC buttons
    ['cl-add-to-cart', 'cl-sticky-btn'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (btn) btn.addEventListener('click', addToCart);
    });

    runUpdate();
  });

})();
